/**
 * convertBase64IntoFile will convert from base64Str to file
 * 
 * @param {string} base64Str base64 string return from server response
 * @param {string} mimeType mimeType is the base64 format
 * @param {string} fileName fileName is the downloadable file
 * 
 * @returns {File} file object
 */
export const convertBase64IntoFile = (
	base64Str, mimeType,
	fileName = "download",
) => {
	
	/* Decoding string from base64 data */
	const byteCharacters = atob(base64Str);

	/* Creating array based upon string length */
	const byteNumbers = new Array(byteCharacters.length);

	/* Iterating on string characters */
	for (let i = 0; i < byteCharacters.length; i++) {

		/* Getting UTF-16 char code for the iterating character */
		byteNumbers[i] = byteCharacters.charCodeAt(i);
	}

	/* Creating an array from array of character codes */
	const byteArray = new Uint8Array(byteNumbers);

	/* Generating the blob file */
	return new File([byteArray], fileName, {type: mimeType});
}

/**
 * generateFileURLFromBase64 will convert base64 to the downloadable URL
 * without hurting CSP
 * 
 * SRC: https://stackoverflow.com/a/52091804/4067157
 * 
 * @param {string} base64Str base64 string return from server response
 * @param {string} mimeType mimeType is the base64 format
 * @param {string} fileName fileName is the downloadable file
 * 
 * @returns {string} downloadable URL
 */
export const generateFileURLFromBase64 = (
	base64Str, mimeType,
	fileName = "download"
) => {

	/* Generating file from base64 */
	const file = convertBase64IntoFile(
		base64Str, mimeType, fileName
	);

	/* Generating the URL */
	return URL.createObjectURL(file);
}